import { Inject, Injectable } from '@angular/core';

export class CampaignUpdate {
	constructor(
		public campaignId: number,
		public leadsAssigned: number,
		public date: any,
	) {}
}

export class CampaignUpdateR {
	constructor(
		public campaignId: number,
		public leadsAssigned: number,
		public date: any,
	) {}
}

export class CampaignUpdateReplacement {
	constructor(
		public campaignId: number,
		public leadsAssigned: number,
		public date: any,
	) {}
}
